module.exports = __webpack_public_path__ + "static/media/img_hotel_default.f436aed6.jpg";